import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroBadgeStyles as styles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing, mixinRobotoRegular } from '../../../styles';

export const customBadgeStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${styles(context, definition)}
  ${boxSizing}
  :host::part(control) {
    display: flex;
    gap: 0.4rem;
    border: 1px solid var(--gray-light);
    border-radius: 4px;
    align-items: center;
    color: var(--nest-level-tab-font);
    ${mixinRobotoRegular}

    font-weight: normal;
  }

  :host ::slotted(svg) {
    height: 12px;
  }
`;
